import React, { useMemo, useState } from "react";
import { Alert, Button } from "antd";
import { WarningOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";

import OrderStatusList from "./OrderStatusList";
import { getRouteDayDelivery } from "../../utils/routeMonitoring";

// Full-width, collapsed-by-default banner for orders with no driver assigned
// on routeDay (driver_id null or the backend's "No asignado" id-0 sentinel).
// Kept out of the driver grid entirely since it isn't a driver's route — just
// a flat list, unlike DriverRouteCard there's no per-status breakdown here.
const UnassignedOrdersAlert = ({ orders, routeDay }) => {
  const [expanded, setExpanded] = useState(false);

  const deliveryStatusByOrder = useMemo(() => {
    const statusByOrder = new Map();
    orders.forEach((order) => {
      const delivery = getRouteDayDelivery(order, routeDay);
      if (delivery) statusByOrder.set(order.order_id, delivery.delivery_status);
    });
    return statusByOrder;
  }, [orders, routeDay]);

  if (orders.length === 0) return null;

  return (
    <Alert
      className="mb-4"
      type="warning"
      showIcon
      icon={<WarningOutlined />}
      message={
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <span>
            {orders.length} pedido{orders.length === 1 ? "" : "s"} sin chofer asignado
          </span>
          <Button
            size="small"
            type="text"
            onClick={() => setExpanded((e) => !e)}
            icon={expanded ? <UpOutlined /> : <DownOutlined />}
          >
            {expanded ? "Ocultar" : "Ver detalle"}
          </Button>
        </div>
      }
      description={
        expanded ? (
          <div className="mt-2 max-h-64 overflow-y-auto bg-white rounded-md">
            <OrderStatusList orders={orders} deliveryStatusByOrder={deliveryStatusByOrder} />
          </div>
        ) : null
      }
    />
  );
};

export default UnassignedOrdersAlert;
